import {createContext, useState} from "react";

export const MainContext = createContext(null);

export const MainContextProvider = ({children}) => {
    const [lang, s_lang] = useState("he");
    const [currentStage, s_currentStage] = useState(1);
    const [categories, s_categories] = useState([]);
    const [templates, s_templates] = useState({});
    const [allTemplates, s_allTemplates] = useState([]);
    const [params, s_params] = useState({});

    return (
        <MainContext.Provider
            value={{
                stageNumberContext: [currentStage, s_currentStage],
                categoriesContext: [categories, s_categories],
                templateContext: [templates, s_templates],
                allTemplateContext: [allTemplates, s_allTemplates],
                paramsContext: [params, s_params],
            }}
        >
            {children}
        </MainContext.Provider>
    );
};